import { Routes } from '@angular/router';
import { maintenanceGuard } from '../../shared/guards/auth-guard.guard';
import { farmboxStepResolver } from './resolvers/farmbox-products.resolver';
import { signupNavigationGuard } from './guards/signup-navigation.guard';

export const signupV2Routes: Routes = [
  {
    path: 'signup',
    title: 'Sign Up',
    loadComponent: () => import('./signup-v2').then(m => m.SignupV2),
    canActivate: [maintenanceGuard],
    children: [
      {
        path: '',
        redirectTo: 'farmbox',
        pathMatch: 'full'
      },
      {
        path: 'farmbox',
        title: 'Select Your Farmbox',
        loadComponent: () => import('./steps/farmbox-step/farmbox-step.component').then(m => m.FarmboxStepComponent),
        canActivate: [signupNavigationGuard],
        data: { step: 0 },
        resolve: {
          farmboxData: farmboxStepResolver
        }
      },
      {
        path: 'delivery',
        title: 'Delivery Information',
        loadComponent: () => import('./steps/delivery-step/delivery-step.component').then(m => m.DeliveryStepComponent),
        canActivate: [signupNavigationGuard],
        data: { step: 1 }
      },
      {
        path: 'personal',
        title: 'Personal Information',
        loadComponent: () => import('./steps/personal-step/personal-step.component').then(m => m.PersonalStepComponent),
        canActivate: [signupNavigationGuard],
        data: { step: 2 }
      },
      {
        path: 'payment',
        title: 'Payment Information',
        loadComponent: () => import('./steps/payment-step/payment-step.component').then(m => m.PaymentStepComponent),
        data: { step: 3 }
      }
    ]
  }
];
